import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule, Routes } from '@angular/router';

import { EditComponent } from './components/edit/edit.component';
import { ListComponent } from './pages/list/list.component';
import { RightsComponent } from './components/rights/rights.component';
import { SharedModule } from '../shared.module';

const routes: Routes = [
  {
    path: '',
    //canActivate: [CanActivateMaintenance],
    children: [
      {
        path: '',
        component: ListComponent,
        data: { animation: 'isLeft' },
      },
    ],
  },
];

@NgModule({
  providers: [],
  declarations: [ListComponent, EditComponent, RightsComponent],
  imports: [CommonModule, RouterModule.forChild(routes), SharedModule],
  exports: [RouterModule],
})
export class UsersModule {}
